/// Global play-count counter shown under the home-screen banner.
///
/// Calls the `incrementWebPlayCount` Cloud Function once per home
/// mount: every visit (signed-in or anonymous) bumps the count by
/// one, and the function returns the new total. Counter doc lives
/// at `webStats/global.playCount` and is server-written only —
/// clients never write it directly, so a Firestore rule for the
/// doc isn't needed and the count can't be inflated from a console.

import { httpsCallable } from 'firebase/functions'
import { firebaseFunctions } from '../firebase/app'

interface IncrementResult {
  playCount: number
}

export async function incrementAndFetchPlayCount(): Promise<number> {
  const fn = httpsCallable<unknown, IncrementResult>(
    firebaseFunctions,
    'incrementWebPlayCount',
  )
  const res = await fn({})
  return res.data.playCount
}
